import {useEffect} from 'react'

export const useClearSession = () => {
  useEffect(() => {
    window.sessionStorage.removeItem('jwt')
    window.sessionStorage.removeItem('shareJwt')
    window.sessionStorage.removeItem('shareData')
    window.sessionStorage.removeItem('patientName')
    window.sessionStorage.removeItem('acceptedTermsKey')
  },[])
}